import { DeleteButton, EditButton, List, Table, useTable } from "@pankod/refine-antd";
import React from "react";

export const Trophy: React.FC = () => {
  const { tableProps } = useTable({
    resource: "trophy",
    initialSorter: [
      {
        field: "point",
        order: "asc",
      },
    ],
  });
  const columns = [
    {
      title: "Title",
      dataIndex: "name",
      key: "name",
      width: "70%",
    },
    {
      title: "Rank",
      dataIndex: "rank",
      key: "rank",
    },
    {
      title: "Trophy",
      dataIndex: "point",
      key: "point",
    },
    {
      title: "Actions",
      render: (_: any, record: any) => {
        return (
          <div className="flex space-x-2">
            <EditButton shape="circle" hideText recordItemId={record.id} />
            <DeleteButton shape="circle" hideText recordItemId={record.id} resourceNameOrRouteName="trophy" />
          </div>
        );
      },
      width: "10%",
    },
  ];
  return (
    <List title={<h1 style={{fontSize: 35, marginTop:20, color:"rgb(4, 6, 10, 0.8)"}}>Trophies</h1>} canCreate>
      <Table
        {...tableProps}
        rowKey="id"
        columns={columns}
        pagination={{
          ...tableProps.pagination,
        }}
      />
    </List>
  );
};
